import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";

import {
  successMessage,
  errorMessage,
  capitalizeString,
} from "../CommonFunctions";
import {
  POST_ExpenseInsert,
  POST_ExpenseUpdate,
  POST_GetExpenseDetailByID,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";

const AddExpenses = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const calculationTypeOptions = [
    { label: "Fixed Amount", value: 1 },
    { label: "Percentage", value: 2 },
  ];

  const validationSchema = Yup.object().shape({
    ExpenseName: Yup.string().trim().required("Expense Name is required field"),
    DefaultRate: Yup.string().required("Default Rate is required field"),
    CalcType: Yup.string()
      .trim()
      .required("Calculation Type is required field"),
  });

  useEffect(() => {
    if (PrimaryIdParam) {
      getExpensesDetailsByID();
    }
  }, []);

  const getExpensesDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetExpenseDetailByID, {
      ExpenseIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ExpenseIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      ExpenseName: "",
      DefaultRate: "",
      CalcType: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      ExpenseName: values?.ExpenseName.trim(),
      DefaultRate: `${values?.DefaultRate}`,

      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(PrimaryIdParam ? POST_ExpenseUpdate : POST_ExpenseInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/expenses");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Expenses
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Expense Name"
                        name="ExpenseName"
                        placeholder={"Enter Expense Name"}
                        component={CustomInput}
                        required
                        maxLength={500}
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ExpenseName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Calculation Type"
                        name="CalcType"
                        placeholder={"Select Paper Type"}
                        options={calculationTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="number"
                        label="Default Rate"
                        name="DefaultRate"
                        placeholder={"Default Rate"}
                        component={CustomInput}
                        required
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddExpenses;
